import { TransportQuote } from './types';

export type QuoteIdentity = Pick<
  TransportQuote,
  'rateCardId' | 'serviceName' | 'vehicleType'
>;

export function isSameQuote(
  quote: QuoteIdentity,
  rateCardId: string,
  serviceName: string,
  vehicleType: string
): boolean {
  return (
    quote.rateCardId === rateCardId &&
    (quote.serviceName || '') === (serviceName || '') &&
    (quote.vehicleType || '') === (vehicleType || '')
  );
}

export function getQuoteKey(quote: QuoteIdentity): string {
  return `${quote.rateCardId}|${quote.serviceName ?? ''}|${
    quote.vehicleType ?? ''
  }`;
}
